import type { JSX } from 'react'
import type { ISkeletonProps } from '../Skeleton'

import { RowSkeleton } from 'blocks/Skeletons/components/RowSkeleton/RowSkeleton'
import { MainPageSkeletonSC } from 'blocks/Skeletons/Skeleton.styled'
import { CardsInRow } from 'containers/RowContainer/RowContainer.h'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { Skeleton } from '../Skeleton'

export interface ICategoriesPageSkeletonProps extends ISkeletonProps {
  gap?: FIXED_INDENTS
  cardsInRow: CardsInRow
}

export const CategoriesPageSkeleton = ({
  gap = FIXED_INDENTS.INDENT_140,
  cardsInRow = CardsInRow.Horizontal_3,
  ...rest
}: ICategoriesPageSkeletonProps): JSX.Element => {
  return (
    <Skeleton {...rest}>
      <MainPageSkeletonSC gap={gap}>
        <RowSkeleton cardsInRow={cardsInRow} />
        <RowSkeleton cardsInRow={cardsInRow} />
        <RowSkeleton cardsInRow={cardsInRow} />
        <RowSkeleton cardsInRow={cardsInRow} />
      </MainPageSkeletonSC>
    </Skeleton>
  )
}
